export * from "./cmsInformations"

export const isCmsConnected = (integration: { connected: boolean }) =>
  integration.connected
